import React from "react";
import { useTranslation } from "react-i18next";
import VoicesCard from "../Common/VoicesCard";
import VoicesPostBrowser from "../Posts/VoicesPostBrowser";

const VoicesAllPosts: React.FC = () => {
  const { t } = useTranslation("voicesPosts");

  return (
    <VoicesCard title={t("posts_title")} subtitle={t("posts_subtitle")}>
      <VoicesPostBrowser />
    </VoicesCard>
  );
};

export default VoicesAllPosts;
